import styles from '../styles/components/spinner.module.css';
import { ReactComponent as SpinnerSvg } from "../assets/spinner.svg";

export default function Spinner() {
    return <SpinnerSvg className={styles.spinner}/>;
};